export default class ProductTypeUtils {
    static PRODUCT_TYPE = {
        SILVER_TYPE: 'LARGEAPPLIANCE',
        GIFT_CARD: 'GIFTCARD',
    };

    static isSilverProduct(type) {
        return ProductTypeUtils.PRODUCT_TYPE.SILVER_TYPE === type;
    }

    static isGiftCard(type) {
        return ProductTypeUtils.PRODUCT_TYPE.GIFT_CARD === type;
    }
}
